import React, { FC, useState } from 'react';
import Modal from '@minecraft.modal';
import { dateFormat, getDateWithTimeZone } from '@minecraft.date-utils';
import { NoteType } from '../../../shared/types';
import { StyledButton, NotesList, Header, Note, Signature, StyledIcon } from './TalentCardFCNoteStyles';

type Props = {
  fastCaptureNotes: readonly NoteType[];
};

const TalentCardFCNote: FC<Props> = ({ fastCaptureNotes }) => {
  const [fCNoteIsOpen, setFCNoteIsOpen] = useState<boolean>(false);

  const toggle = () => setFCNoteIsOpen((currentState) => !currentState);

  return (
    <>
      <StyledButton onClick={toggle} color="link">
        <StyledIcon name="fast-capture" /> FastCapture Note
      </StyledButton>
      {fCNoteIsOpen && (
        <Modal
          isOpen={fCNoteIsOpen}
          title="FastCapture Note"
          modalSize="small"
          cancelLabel="Cancel"
          submitLabel="OK"
          handleToggleClick={toggle}
          handleSubmitClick={toggle}
        >
          <NotesList>
            <Header>Casting Note</Header>
            {fastCaptureNotes.map((note) => (
              <Note key={note.id}>
                <Signature>
                  by {note.account.firstName} {note.account.lastName} on{' '}
                  {getDateWithTimeZone(note.created, dateFormat.MONTH_DAY_YEAR_TIME, note?.account?.timeZone)}
                </Signature>
                <div>{note.comment}</div>
              </Note>
            ))}
          </NotesList>
        </Modal>
      )}
    </>
  );
};

export default TalentCardFCNote;
